$(document).ready(function(){$('#cssmenu > ul > li > a').click(function(){$('#cssmenu li').removeClass('active');$(this).closest('li').addClass('active');var checkElement=$(this).next();if((checkElement.is('ul'))&&(checkElement.is(':visible'))){$(this).closest('li').removeClass('active');checkElement.slideUp('normal');}if((checkElement.is('ul'))&&(!checkElement.is(':visible'))){$('#cssmenu ul ul:visible').slideUp('normal');checkElement.slideDown('normal');}if($(this).closest('li').find('ul').children().length==0){return true;}else{return false;}});});$(function(){var button=$('#loginButton');var box=$('#loginBox');var form=$('#loginForm');button.removeAttr('href');button.mouseup(function(login){box.toggle();button.toggleClass('active');});form.mouseup(function(){return false;});$(this).mouseup(function(login){if(!($(login.target).parent('#loginButton').length>0)){button.removeClass('active');box.hide();}});});

//LOGIN
function toggleLoginModal(){
  $('#loginModal').modal('toggle');
}

$(document).on('submit', '#formLogin', function(e) {
    e.preventDefault();

    $('#errorMessagesLogin').addClass('hidden');

    var emailVal = $('#formLogin input[name=email]').val();
    var passVal = $('#formLogin input[name=password]').val();

    if(!emailVal || !passVal){
      if(!emailVal){
        var input = '#formLogin input[name=email]';
        $(input + '+small').text(Lang.get("messages.loginNoEmail"));
        $(input).parent().addClass('has-error');
      }

      if(!passVal){
        var input = '#formLogin input[name=password]';
        $(input + '+small').text(Lang.get("messages.loginNoPassword"));
        $(input).parent().addClass('has-error');
      }

      return;
    }

    $('input+small').text('');
    $('input').parent().removeClass('has-error');

    $.ajax({
        method: $(this).attr('method'),
        url: $(this).attr('action'),
        data: $(this).serialize(),
        dataType: "json"
    })
    .done(function(data) {
      if(data.auth)
        window.location.href = data.intended
      else{
        $('#errorMessagesLogin').removeClass('hidden');
      }
    })
    .fail(function(data) {
        $.each(data.responseJSON, function (key, value) {
            var input = '#formLogin input[name=' + key + ']';
            $(input + '+small').text(value);
            $(input).parent().addClass('has-error');
        });
    });
});

//REGISTRATION
function toggleRegisterModal(){
  setNewsletterVisibility($('#fgReceiveNewsletter')[0]);

  $('#registerModal').modal('toggle');
}

function closeRegisterModal(){
  $('#registerModalBackdrop').remove();
  $('#registerModal').modal('hide');
  $('#registerModal').removeClass('show');
  $('#registerModal').removeClass('in');
}

$(document).on('change', '#fgReceiveNewsletter', function(ev) {
  setNewsletterVisibility(ev.target);
});

function setNewsletterVisibility(el){
  if(el.checked){
    $('#formRegister > .newsletter-data').removeClass('hidden');
  }
  else{
    $('#formRegister > .newsletter-data').addClass('hidden');
  }
}

$(document).on('submit', '#formRegister', function(e) {
    e.preventDefault();

    $('input+small').text('');
    $('#register-categories-err').text('');
    $('input').parent().removeClass('has-error');

    var hasErrors = false;


    var nameVal = $('#formRegister input[name=name]').val();
    if(!nameVal){
      var input = '#formRegister input[name=name]';
      $(input + '+small').text(Lang.get("validation.required", {"attribute": Lang.get("messages.registerName")}));
      $(input).parent().addClass('has-error');

      hasErrors = true;
    }

    var emailVal = $('#formRegister input[name=email]').val();
    if(!emailVal){
      var input = '#formRegister input[name=email]';
      $(input + '+small').text(Lang.get("validation.required", {"attribute": Lang.get("messages.registerEmail")}));
      $(input).parent().addClass('has-error');

      hasErrors = true;
    }

    var passVal = $('#formRegister input[name=password]').val();
    if(!passVal){
      var input = '#formRegister input[name=password]';
      $(input + '+small').text(Lang.get("validation.required", {"attribute": Lang.get("messages.registerPassword")}));
      $(input).parent().addClass('has-error');

      hasErrors = true;
    }

    var repeatPassVal = $('#formRegister input[name=password_confirmation]').val();
    if(!repeatPassVal){
      var input = '#formRegister input[name=password_confirmation]';
      $(input + '+small').text(Lang.get("validation.required", {"attribute": Lang.get("messages.registerConfirmPassword")}));
      $(input).parent().addClass('has-error');

      hasErrors = true;
    }
    else if(passVal !== repeatPassVal){
      var input = '#formRegister input[name=password_confirmation]';
      $(input + '+small').text(Lang.get("validation.confirmed", {"attribute": Lang.get("messages.registerPassword")}));
      $(input).parent().addClass('has-error');

      hasErrors = true;
    }

    var receiveNewsVal = $('#formRegister input[name=fgReceiveNewsletter]').is(':checked');
    var newsCatsVal = $("#formRegister input[name=newsletterCategories\\[\\]]:checked").length;

    if(receiveNewsVal && newsCatsVal < 1){
      var input = '#formRegister input[name=password_confirmation]';
      $('#register-categories-err').text(Lang.get("messages.registerCategoriesNotChoosen"));
      $('#register-categories-err').parent().addClass('has-error');

      hasErrors = true;
    }

    if(receiveNewsVal && newsCatsVal > 3){
      var input = '#formRegister input[name=password_confirmation]';
      $('#register-categories-err').text(Lang.get("messages.registerMoreCategoriesChoosen"));
      $('#register-categories-err').parent().addClass('has-error');

      hasErrors = true;
    }

    if(hasErrors)
      return;

    $.ajax({
        method: $(this).attr('method'),
        url: $(this).attr('action'),
        data: $(this).serialize(),
        dataType: "json"
    })
    .done(function(data) {
        $('#registration-alert').removeClass('hidden')
        $('#registerModal').modal('hide');
    })
    .fail(function(data) {
      if(data.status == 200){
        $('#registration-alert').removeClass('hidden')
        $('#registerModal').modal('hide');
      }
      else {
        $.each(data.responseJSON, function (key, value) {
            var input = '#formRegister input[name=' + key + ']';
            $(input + '+small').text(value);
            $(input).parent().addClass('has-error');
        });
      }
    });
});
